export class FilterMasterModel{
   public childList:any[]=[];
   public predefinedId:number; 
}